import FlowsAPI from '../api/flows';

const state = () => ({
  flows: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isSaving: false,
    isPublishing: false,
    isPausing: false,
    isDeleting: false,
  },
});

const getters = {
  getFlows: s => s.flows,
  getFlowById: s => id => s.flows.find(f => f.id === id),
  getActiveFlows: s => s.flows.filter(f => f.status === 'active'),
  getUIFlags: s => s.uiFlags,
};

const actions = {
  fetch: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await FlowsAPI.index();
      commit('SET_FLOWS', response.data.data ?? []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, payload) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await FlowsAPI.create(payload);
      const flow = response.data.data;
      commit('ADD_FLOW', flow);
      return flow;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...payload }) => {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      const response = await FlowsAPI.update(id, payload);
      const flow = response.data.data;
      commit('UPDATE_FLOW', flow);
      return flow;
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },

  destroy: async ({ commit }, id) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await FlowsAPI.destroy(id);
      commit('REMOVE_FLOW', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  publish: async ({ commit }, id) => {
    try {
      const response = await FlowsAPI.publish(id);
      const flow = response.data.data;
      commit('UPDATE_FLOW', flow);
      return flow;
    } catch (e) {
      const errBody = e?.response?.data;
      const errors = errBody?.errors ?? errBody?.error;
      let message = null;
      if (Array.isArray(errors)) message = errors.join('; ');
      else if (typeof errors === 'string') message = errors;
      const error = new Error(message ?? 'publish failed');
      if (Array.isArray(errors)) error.apiErrors = errors;
      else error.apiErrors = message ? [message] : [];
      throw error;
    }
  },

  pause: async ({ commit }, id) => {
    try {
      const response = await FlowsAPI.pause(id);
      const flow = response.data.data;
      commit('UPDATE_FLOW', flow);
      return flow;
    } catch (e) {
      const errBody = e?.response?.data;
      const errors = errBody?.errors ?? errBody?.error;
      let message = null;
      if (Array.isArray(errors)) message = errors.join('; ');
      else if (typeof errors === 'string') message = errors;
      throw new Error(message ?? 'pause failed');
    }
  },

  cancelRuns: async (_, id) => {
    await FlowsAPI.cancelRuns(id);
  },
};

const mutations = {
  SET_UI_FLAG: (s, flags) => {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
  SET_FLOWS: (s, flows) => {
    s.flows = flows;
  },
  ADD_FLOW: (s, flow) => {
    s.flows.push(flow);
  },
  UPDATE_FLOW: (s, flow) => {
    const idx = s.flows.findIndex(f => f.id === flow.id);
    if (idx !== -1) s.flows.splice(idx, 1, flow);
  },
  REMOVE_FLOW: (s, id) => {
    s.flows = s.flows.filter(f => f.id !== id);
  },
};

export default { namespaced: true, state, getters, actions, mutations };
